import { create } from 'zustand';
import apiClient from '../api/api';
import { API_ENDPOINTS } from '../endpoints';

const useDashboardStore = create((set) => ({
  dashboardData: null,
  loading: true,
  error: null,
  fetchDashboardData: async () => {
    try {
      set({ loading: true, error: null });
      const response = await apiClient.get(API_ENDPOINTS.getDashboard);
      set({ dashboardData: response.data, loading: false });
    } catch (error) {
      set({ error: 'Failed to fetch dashboard data.', loading: false });
      console.error(error);
    }
  },
}));

export default useDashboardStore;
